var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMenuComment = function SvgIconMenuComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.822 17.797H19.9a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5h-14a.5.5 0 0 0-.5.5v14.67l2.422-1.873ZM3.9 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12.297a2 2 0 0 1-2 2H8.334l-3.306 2.555a.7.7 0 0 1-1.128-.554V5Z",
    fill: "#343637"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9 9.213a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75ZM8.9 13.192a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z",
    fill: "#343637"
  })));
};
export default SvgIconMenuComment;